'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITextInput from 'UIComponents/input/UITextInput';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { domainContainsPath, isValidDomain, getDomainPathInfo, domainContainsProtocol, getDomainProtocolInfo } from '../validation/PropertyValidations';
import { getTransferrableProps } from '../utils/getTransferrableProps';

const _UITextInput$propType = UITextInput.propTypes,
      inputPropTypes = _objectWithoutPropertiesLoose(_UITextInput$propType, ["styled"]);

const propTypes = Object.assign({
  autoFocus: PropTypes.bool,
  showError: PropTypes.bool,
  value: PropTypes.string
}, inputPropTypes);
const defaultProps = UITextInput.defaultProps;

class PropertyInputDomain extends PureComponent {
  constructor() {
    super();

    this.handleBlur = () => {
      return this.setState({
        hasBlurred: true
      });
    };

    this.handleFocus = () => {
      return this.setState({
        hasBlurred: false
      });
    };

    this.state = {
      hasBlurred: false
    };
  }

  getValue() {
    const {
      value
    } = this.props;

    if (value == null) {
      return '';
    }

    return `${value}`;
  }

  shouldShowError() {
    const {
      hasBlurred
    } = this.state;
    const {
      showError
    } = this.props;
    const propertyValue = this.getValue();
    return showError && hasBlurred && propertyValue && (!isValidDomain(propertyValue) || domainContainsPath(propertyValue) || domainContainsProtocol(propertyValue));
  }

  getPathInfo() {
    const propertyValue = this.getValue();
    return propertyValue && getDomainPathInfo(propertyValue);
  }

  getProtocolInfo() {
    const propertyValue = this.getValue();
    return propertyValue && getDomainProtocolInfo(propertyValue);
  }

  renderValidationError() {
    const propertyValue = this.getValue();

    if (!this.shouldShowError()) {
      return null;
    }

    const {
      path,
      domain
    } = this.getPathInfo();
    const {
      protocol
    } = this.getProtocolInfo();

    if (protocol && path) {
      return /*#__PURE__*/_jsx("div", {
        className: "is--text--error",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidDomainBoth",
          options: {
            domain,
            protocol,
            path
          }
        })
      });
    }

    if (protocol) {
      return /*#__PURE__*/_jsx("div", {
        className: "is--text--error",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidProtocol",
          options: {
            domain,
            protocol
          }
        })
      });
    }

    if (path) {
      return /*#__PURE__*/_jsx("div", {
        className: "is--text--error",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidPath",
          options: {
            domain,
            path
          }
        })
      });
    }

    return /*#__PURE__*/_jsx("div", {
      className: "is--text--error",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.PropertyDomain.error.invalidDomain",
        options: {
          domain: propertyValue
        }
      })
    });
  }

  render() {
    return /*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        xs: 12
      },
      className: "p-x-0",
      children: [/*#__PURE__*/_jsx(UITextInput, Object.assign({}, getTransferrableProps(this.props), {
        autoFocus: this.props.autoFocus,
        inputRef: this.props.inputRef,
        value: this.getValue(),
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      })), this.renderValidationError()]
    });
  }

}

PropertyInputDomain.propTypes = propTypes;
PropertyInputDomain.defaultProps = defaultProps;
export default PropertyInputDomain;